const topics = [
  { label: '热血少年', color: 'bg-primary-100 text-primary-700', icon: 'ri-fire-line' },
  { label: '恋爱甜宠', color: 'bg-accent-100 text-accent-700', icon: 'ri-heart-line' },
  { label: '悬疑推理', color: 'bg-secondary-100 text-secondary-700', icon: 'ri-search-eye-line' },
  { label: '奇幻冒险', color: 'bg-primary-100 text-primary-700', icon: 'ri-rocket-line' },
  { label: '古风仙侠', color: 'bg-accent-100 text-accent-700', icon: 'ri-sword-line' },
  { label: '都市日常', color: 'bg-secondary-100 text-secondary-700', icon: 'ri-building-line' },
  { label: '搞笑日常', color: 'bg-primary-100 text-primary-700', icon: 'ri-emotion-laugh-line' },
  { label: '异世界', color: 'bg-accent-100 text-accent-700', icon: 'ri-earth-line' },
  { label: '治愈系', color: 'bg-secondary-100 text-secondary-700', icon: 'ri-mental-health-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            专题合集
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">热门专题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选九大热门漫画专题，无论是热血战斗还是甜蜜恋爱，找到你的专属阅读频道
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className={`${topic.color} rounded-xl p-4 md:p-6 flex flex-col items-center gap-3 text-center transition-all hover:scale-[1.02] cursor-pointer`}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-white/60">
                <i className={`${topic.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading text-sm md:text-base whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-60">{
                ['2000+ 作品', '1800+ 作品', '900+ 作品', '1500+ 作品', '1200+ 作品', '1100+ 作品', '1600+ 作品', '2500+ 作品', '800+ 作品'][i]
              }</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}